import firebase from "firebase/app";

import { UnlistenerFunction } from "../friends/types";
import {
  Desk,
  ItemRef,
  HandDocument,
  GameInfo,
  Announcement,
  PlayerSides,
  Restriction,
  CARDS,
  GameMode,
  FriendRef,
  ANON_CARDS,
} from "@dokogd/shared";

export interface WaitingPlayer extends FriendRef {
  joined: boolean;
}

export type GameModeInfos = {
  mode: GameMode | null;
  restriction: {
    playerId: string;
    type: Restriction<ANON_CARDS[]>;
  } | null;
} | null;

export class DeskState {
  id: null | string = null;
  invitesUnlistener: null | UnlistenerFunction = null;
  invites: ItemRef[] = [];
  deskUnlistener: null | UnlistenerFunction = null;
  desk: Desk<firebase.firestore.Timestamp> | null = null;
  gameUnlistener: null | UnlistenerFunction = null;
  gameInfo: GameInfo | null = null;
  hands: (number | HandDocument)[] = [10, 10, 10, 10];
  loading = true;
  displayGameMode = false;
  watchGame = 0;
}

export interface DeckInfo {
  owner: FriendRef;
  cards: string[] | number;
  trickCount: number;
  announcement: Announcement | null;
  nextAnnouncement: Announcement | null;
  side: PlayerSides | null;
}

export interface Decks {
  bottom: DeckInfo;
  left: DeckInfo;
  top: DeckInfo;
  right: DeckInfo;
}

export type PlaceName = "bottom" | "left" | "top" | "right";
export interface ReleativOrderEntry {
  place: PlaceName;
  participantIdx: number;
  participantId: string;
}

export interface PovertyCards {
  isFoxPoverty: boolean;
  trump: CARDS[];
  nontrumps: CARDS[];
}
